import util from '../util';

export const GROUP = 'GROUP';
export const GROUPS = 'GROUPS';
export const GROUP_CREATE = 'GROUP_CREATE';
export const GROUP_UPDATE = 'GROUP_UPDATE';
export const TMP_GROUP_UPDATE = 'TMP_GROUP_UPDATE';
export const RESET_GROUP = 'RESET_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP';

export const GROUPS_REQUEST = util.requestType(GROUPS);
export const GROUPS_SUCCESS = util.successType(GROUPS);
export const GROUPS_FAILURE = util.failureType(GROUPS);

export const GROUP_REQUEST = util.requestType(GROUP);
export const GROUP_SUCCESS = util.successType(GROUP);
export const GROUP_FAILURE = util.failureType(GROUP);

export const CREATE_GROUP_REQUEST = util.requestType(GROUP_CREATE);
export const CREATE_GROUP_SUCCESS = util.successType(GROUP_CREATE);
export const CREATE_GROUP_FAILURE = util.failureType(GROUP_CREATE);

export const UPDATE_GROUP_REQUEST = util.requestType(GROUP_UPDATE);
export const UPDATE_GROUP_SUCCESS = util.successType(GROUP_UPDATE);
export const UPDATE_GROUP_FAILURE = util.failureType(GROUP_UPDATE);

export const UPDATE_TMP_GROUP_REQUEST = util.requestType(TMP_GROUP_UPDATE);
export const UPDATE_TMP_GROUP_SUCCESS = util.successType(TMP_GROUP_UPDATE);
export const UPDATE_TMP_GROUP_FAILURE = util.failureType(TMP_GROUP_UPDATE);

export const DELETE_GROUP_REQUEST = util.requestType(DELETE_GROUP);
export const DELETE_GROUP_SUCCESS = util.successType(DELETE_GROUP);
export const DELETE_GROUP_FAILURE = util.failureType(DELETE_GROUP);
